<div class="flex flex-row space-x-2">
    <div class="w-8">
        <div class="aspect-h-1 aspect-w-1">
            @if (category?.category?.icon) {
                <app-lazy-asset
                    [configuration]="assetConfiguration"></app-lazy-asset>
            }
        </div>
    </div>
    <div class="w-full space-y-4">
        <h3 class="w-1/2 rounded border-b-2 border-mediumgrey">
            {{ category?.category.name }}
        </h3>

        @for (article of category?.articles; track article.sys.id) {
            <div>
                <app-link
                    (mousedown)="preloadArticle(article)"
                    (touchstart)="preloadArticle(article)"
                    [link]="'/knowledge/' + article.urlSlug"
                    [routerLinkInActive]="['text-link-blue']"
                    [routerLinkActive]="['text-darkgrey']">
                    {{ article.shortTitle }}
                </app-link>
            </div>
        }
    </div>
</div>
